<template lang="html">
  <v-dialog
    v-model="opened"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.xsOnly"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card>
      <v-card-title class="title pb-0">
        <p v-if="selectedView === 'users'">
          Bulk Update Contact Tags ({{ selectedClients.length }})
        </p>
        <p v-else>Bulk Update Entity Tags ({{ selectedEntities.length }})</p>
        <v-spacer />
        <v-btn
          fab
          small
          class="error--text text-none my-0"
          flat
          @click="$emit('update:opened', false)"
        >
          <v-icon>clear</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="text-xs-left pt-0">
        <v-tabs v-model="activeTab" color="white" slider-color="primary">
          <v-tab key="add" ripple class="text-none subheading">
            Add Tags
          </v-tab>
          <v-tab key="remove" ripple class="text-none subheading">
            Remove Tags
          </v-tab>

          <v-tab-item key="add" class="pt-4">
            <v-autocomplete
              class="default-input"
              :items="firmContactTags"
              v-model="selectedTags"
              placeholder="None"
              item-text="name"
              item-value="name"
              solo
              chips
              small-chips
              multiple
            />
            <v-divider class="my-4" />
            <v-layout align-center>
              <v-text-field
                v-model="newTag"
                hide-details
                class="default-input"
                solo
                placeholder="New Tag Name"
              />
              <v-btn
                class="primary text-none"
                @click="addTag()"
                :disabled="isEmpty(newTag)"
              >
                Add Tag
              </v-btn>
            </v-layout>
          </v-tab-item>
          <v-tab-item key="remove" class="pt-4">
            <v-autocomplete
              class="default-input"
              :items="firmContactTags"
              v-model="selectedTags"
              placeholder="None"
              item-text="name"
              item-value="name"
              solo
              chips
              small-chips
              multiple
            />
          </v-tab-item>
        </v-tabs>
      </v-card-text>
      <v-card-actions>
        <v-spacer class="hidden-xs-only" />
        <v-btn
          class="primary text-none"
          @click="saveTags()"
          :disabled="isEmpty(selectedTags)"
        >
          Save
        </v-btn>
        <v-btn
          outline
          class="error--text text-none"
          @click="$emit('update:opened', false)"
        >
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import moment from 'moment';
import API from '@/api';
import { mapState, mapGetters } from 'vuex';
import isEmpty from 'lodash/isEmpty';
import take from 'lodash/take';
import get from 'lodash/get';

export default {
  name: 'BulkUpdateTagsDialog',
  data() {
    return {
      newTag: '',
      selectedTags: [],
      activeTab: 1,
      commonTags: [],
    };
  },
  props: {
    opened: {
      type: Boolean,
    },
    selectedClients: {
      type: Array,
    },
    selectedEntities: {
      type: Array,
    },
    selectedView: {
      type: String,
    },
  },
  computed: {
    ...mapGetters(['isAdvisor']),
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),
    firmContactTags() {
      if (this.currentFirm) {
        if (this.selectedView === 'users') {
          return this.currentFirm.contact_tags;
        } else {
          return this.currentFirm.entity_tags;
        }
      } else {
        return [];
      }
    },
  },
  methods: {
    moment,
    isEmpty,
    tagAlreadyExists(tag) {
      if (this.selectedView === 'users') {
        return this.currentFirm.contact_tags.includes(tag);
      } else {
        return this.currentFirm.entity_tags.includes(tag);
      }
    },
    async addTag() {
      if (this.tagAlreadyExists(this.newTag)) {
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Tag already exists',
        });
        return;
      }
      try {
        const response =
          this.selectedView === 'users'
            ? await API.firm.addClientTag(this.newTag)
            : await API.firm.addEntityTag(this.newTag);

        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Tag created!',
          });
          this.$store.dispatch('setCurrentFirm');
          this.selectedTags.push(this.newTag);
          this.newTag = '';
        }
      } catch (e) {
        console.error(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem adding the tag. Please try again after refreshing the page.',
        });
      }
    },
    async saveTags() {
      try {
        const response =
          this.selectedView === 'users'
            ? await API.user.saveTags({
                userIds: this.selectedClients.map(a => a.id),
                selectedTags: this.selectedTags,
                remove: this.activeTab === 1,
              })
            : await API.company.updateTagsInBulk({
                companyIds: this.selectedEntities.map(a => a.id),
                selectedTags: this.selectedTags,
                remove: this.activeTab === 1,
              });

        if (response.data.error) {
          this.$store.dispatch('application/setErrorNotification', {
            message: response.data.error,
          });
        } else {
          this.$store.dispatch('application/setSuccessNotification', {
            message:
              'Bulk Updated Tags. Please wait up to few minutes to refresh',
          });
          this.reset();
          this.$emit('refresh-clients');
          this.$emit('update:opened', false);
        }
      } catch (e) {
        console.error(e);
        this.$store.dispatch('application/setErrorNotification', {
          message:
            'There was a problem saving the tags. Please try again after refreshing the page.',
        });
      }
    },
    reset() {
      this.activeTab = 0;
      this.selectedTags = [];
      this.newTag = '';
    },
  },
  watch: {
    opened: {
      handler(value) {
        if (value) {
          this.reset();
        }
      },
    },
  },
};
</script>

<style lang="postcss" scoped></style>
